export enum QUICK_SEARCH {
    /**
     * @value Ask %AGENT% for %QUERY%
     */
    ASK_FOR = 'FRONT.QUICK_SEARCH.ASK_FOR',
    /**
     * @value Previous query
     * @description label display on the icon to explicit for accessibility purpose
     */
    HISTORY_ITEM = 'FRONT.QUICK_SEARCH.HISTORY_ITEM',
    /**
     * @value Search history
     * @description Suggestion section for past queries
     */
    HISTORY_SUGGEST = 'FRONT.QUICK_SEARCH.HISTORY_SUGGEST',
    /**
     * @value Previously viewed
     * @description Suggestion section for interacted results
     */
    INTERACTION_SUGGEST = 'FRONT.QUICK_SEARCH.INTERACTION_SUGGEST',
    /**
     * @value Suggestions
     * @description Suggestion section for other items (suggestions from gcs for example)
     */
    OTHER_SUGGEST = 'FRONT.QUICK_SEARCH.OTHER_SUGGEST',
    /**
     * @value Recommendations
     * @description section title
     */
    RECOMMENDATIONS_SUGGEST = 'QUICK_SEARCH.RECOMMENDATIONS_SUGGEST',
    /**
     * @value Remove "%OPTION_NAME%" from suggestions
     * @description Helper set on the "remove" icons from the quick search
     */
    REMOVE_OPTION_FROM_SUGGESTIONS = 'QUICK_SEARCH.REMOVE_OPTION_FROM_SUGGESTIONS',
    /**
     * @value Search for %QUERY%
     */
    SEARCH_FOR = 'FRONT.QUICK_SEARCH.SEARCH_FOR',
    /**
     * @value Your agents
     * @description Title of the Agent section in the search box suggestions
     */
    YOUR_AGENTS = 'QUICK_SEARCH.YOUR_AGENTS',
}
